import { AgTechQuery, AgTechQueryBuilder, AgTechQueryResponses } from "@agtech/core/data/queries/AgTechDataQueries";
import { useReportDataGetAfterSaleReportRequest, useReportDataGetOutstandingCreditsReportRequest, useReportDataGetLotOrderReportRequest, useReportDataGetLotsByPurchaserReportRequest, useReportDataGetLotsPurchasedInOrderReportRequest, useReportDateGetUnpaidInvoicesRequest } from "./ReportDataActions";
import { SaleReport } from "./ReportData";
import { useCurrentSale } from "../sales/SaleDataStore";

export const ReportDataGetSaleReportsQuery: AgTechQuery<any, SaleReport[]> = {
    queryKey: () => ['Reports'],
    query: async () => {
        return AgTechQueryResponses.Success<SaleReport[]>([]);
    },
    content: {
        loadingText: 'Loading Reports...',
        failureText: 'Failed to load reports'
    }
}

export const useReportDataGetSaleReportsQuery = () => {
    const currentSale = useCurrentSale();
    const afterSaleReportRequest = useReportDataGetAfterSaleReportRequest();
    const outstandingCreditsReportRequest = useReportDataGetOutstandingCreditsReportRequest();
    const lotOrderReportRequest = useReportDataGetLotOrderReportRequest();
    const lotDetailReportRequest = useReportDataGetLotsByPurchaserReportRequest();
    const lotPurchaseOrderReportRequest = useReportDataGetLotsPurchasedInOrderReportRequest();
    const upaidInvoicesReportRequest = useReportDateGetUnpaidInvoicesRequest();
    
    return AgTechQueryBuilder.buildQueryResult({
        data: [
            {
                reportName: 'After Sale Report',
                reportDescription: 'The after sale report for viewing after the sale.',
                reportDownloadAction: async () => afterSaleReportRequest.execute({
                    data: currentSale.id
                }),
                reportIcon: 'fas fa-chart-area'
            },
            {
                reportName: 'Outstanding Credits Report',
                reportDescription: 'Report for showing outstanding credits',
                reportDownloadAction: async () => outstandingCreditsReportRequest.execute({
                    data: undefined
                }),
                reportIcon: 'fas fa-dollar-sign'
            },
            {
                reportName: 'Lot Order Report',
                reportDescription: 'Report shows lot order for handing out to bidders',
                reportDownloadAction: async () => lotOrderReportRequest.execute({
                    data: currentSale.id
                }),
                reportIcon: 'fas fa-list'
            },
            {
                reportName: 'Lot Details by Purchaser Report',
                reportDescription: 'This report contains lot sale details ordered by lot purchaser.',
                reportDownloadAction: async () => lotDetailReportRequest.execute({
                    data: currentSale.id
                }),
                reportIcon: 'fas fa-list'
            },
            {
                reportName: 'Lot Details by Lot Number Report',
                reportDescription: 'This report contains lot sale details ordered by lot number.',
                reportDownloadAction: async () => lotPurchaseOrderReportRequest.execute({
                    data: currentSale.id
                }),
                reportIcon: 'fas fa-list'
            },
            {
                reportName: 'Unpaid Invoices',
                reportDescription: 'This report contains a list of the unpaid invoices for the current sale.',
                reportDownloadAction: async () => upaidInvoicesReportRequest.execute({
                    data: currentSale.id
                }),
                reportIcon: 'fas fa-list'
            }
        ]
    });
}